import moment from 'moment'
import PropTypes from 'prop-types'

export default function FriendlyDate ({ date, short }) {
  const stdDate = 'MM/DD/YYYY'

  const shortOptions = {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: stdDate,
    lastDay: '[Yesterday]',
    lastWeek: stdDate,
    sameElse: stdDate
  }

  const defaultOptions = {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    lastDay: '[Yesterday]',
    lastWeek: '[Last] dddd',
    sameElse: stdDate
  }

  let result = moment(date).calendar(
    null,
    short ? shortOptions : defaultOptions
  )

  if (date) {
    return <span>{result}</span>
  }
  return <span />
}

FriendlyDate.propTypes = {
  date: PropTypes.string,
  short: PropTypes.bool
}
